var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c(
        "Dialog",
        {
          staticClass: "_components-online-notice-dialog",
          attrs: {
            title: "重要通知",
            clickOverlayClose: _vm.hasClose,
            iClose: _vm.hasClose
          },
          on: { close: _vm.handleClose }
        },
        [
          _c("p", { staticClass: "text1 color-gray-1 mt-6 text-indent" }, [
            _vm._v(
              " 2022年HSYLC峰会，将会延续疫情以来作为最大规模国际交流活动的丰富经验，以云端无国界峰会的形式，如期和大家见面，并将在峰会期间根据疫情防控要求，举办同城小组交流活动，开放三场所有嘉宾大师课和世界名校招生官活动，为同学们创造更多元的可能性。 "
            )
          ]),
          _vm.hasBtn
            ? _c(
                "Button",
                { staticClass: "btn", on: { click: _vm.handleSubmitBtn } },
                [_vm._v("查看通知全文")]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }